const state = {
    cart: Array.isArray(JSON.parse(sessionStorage.getItem('cart'))) 
      ? JSON.parse(sessionStorage.getItem('cart')) 
      : [],
  };
  
export default state;